export default "__VITE_ASSET__CqAu2KOR__"